import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import T from 'i18n-react';
import { connect } from '../../redux/connect';
import {
  updateIssueAction,
  trackEvent,
  setIsShowingPushpinVisibilityPopUp,
  togglePushpinVisibility,
  setIsShowingDeletePushpinPopUp,
  deletePushpin,
  clearAllThumbnails,
  issueTransitionPopupChange,
} from '../../redux/actions';
import {
  getCurrentPreviewIssueWrapper,
  getCurrentPreviewIssueAttributes,
  getOxygenMappings,
  getCurrentUser,
  getCurrentDocument,
  getDocumentCollection,
  isShowPushpinVisibilityPopUp,
  isChangingPushpinVisibility,
  getCurrentIssuePreviewStatusOptions,
  getFetchingIssuesUrns,
  isShowDeletePushpinPopUp,
  isDeletingPushpin,
} from '../../redux/selectors';
import noop from 'lodash/noop';
import lodashGet from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import IssuePreviewHeader from './components/IssuePreviewHeader';
import IssuePreviewDetailsTab from './components/IssuePreviewDetailsTab';
import IssuePreviewAttachmentsTab from './components/IssuePreviewAttachmentsTab';
import IssuePreviewActivityTab from './components/IssuePreviewActivityTab';
import IssuePreviewTransitionPopUp from './components/IssuePreviewTransitionPopUp';
import IssuePreviewCallToAction from './components/IssuePreviewCallToAction';
import { Loader, StickyScrollableContainer, Tabs } from '@adsk/bim360-matrix-react-components';
import AnimateHeightPopUp from '../AnimateHeightPopUp';
import PushpinVisibilityPopUp from './components/PushpinVisibilityPopUp';
import featureFlags, { FEATURE_FLAGS } from '../../utils/featureFlags';
import {
  issueAttributesType,
  oxygenType,
  documentType,
  documentCollectionType,
  userType,
  pendingIssueFormAttributesType, statusOptionsArrayType,
} from '../../constants/proptype-validation';
import { ISSUE_ATTRIBUTE_NAMES, ISSUE_BE_ATTRIBUTE_NAMES } from '../../constants/issue-attribute-names';
import { FE_TRANSITION_FIELDS } from '../../constants/transitions';
import { screenType } from '../../constants/analytics';
import { viewRFI, getAssigneeTypeByAssigneeId, viewRfiTabSwitch } from '../../utils/analytics-helpers';
import { getPermittedAttributes, getPermittedStatuses, isPushpinVisible } from '../../utils/issues-helpers';
import DeletePushpinPopUp from './components/DeletePushpinPopUp';
import StatusIndicator from './components/StatusIndicator';

export class PureIssuePreview extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      selectedTabId: PureIssuePreview.NavigationTabIds.DETAILS,
      changeToStatus: null,
      pendingTransition: null,
      tabs: PureIssuePreview.NavigationTabs,
      showCreateRevisionField: undefined,
    };

    this.handleOnStatusChange = this.handleOnStatusChange.bind(this);
    this.showPushpinVisibilityPopUp = this.showPushpinVisibilityPopUp.bind(this);
    this.hidePushpinVisibilityPopUp = this.hidePushpinVisibilityPopUp.bind(this);
    this.showDeletePushpinPopUp = this.showDeletePushpinPopUp.bind(this);
    this.hideDeletePushpinPopUp = this.hideDeletePushpinPopUp.bind(this);
    this.deletePushpin = this.deletePushpin.bind(this);
    this.updatePushpinVisibility = this.updatePushpinVisibility.bind(this);
    this.onCloseChangeStatusPopup = this.onCloseChangeStatusPopup.bind(this);
    this.onToggleCreateRevision = this.onToggleCreateRevision.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
  }

  componentDidMount() {
    const { issue, currentUser, isFetchingCurrentDocument } = this.props;
    this.initial = Object.assign({}, issue);
    if (issue && lodashGet(currentUser, 'attributes.id') && !isFetchingCurrentDocument) {
      this.analyticsEntityPreview(this.props);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { issue, currentUser, isFetchingCurrentDocument } = nextProps;
    // Send preview analytics event when issue is changes or if we're done fetching the
    // required document information for the current issue or if we're done fetching the current user data
    if ((this.props.issue && issue && issue.id && this.props.issue.id !== issue.id)
      || (this.props.isFetchingCurrentDocument && !isFetchingCurrentDocument)
      || (this.props.currentUser.loading && !currentUser.loading)) {
      this.activityCommentEditorState = null;

      if (lodashGet(currentUser, 'attributes.id') && !isFetchingCurrentDocument) {
        this.analyticsEntityPreview(nextProps);
      }
    }
  }

  componentDidUpdate(prevProps) {
    const issueId = lodashGet(this.props, 'issue.id');
    const prevIssueId = lodashGet(prevProps, 'issue.id');

    if (prevIssueId !== issueId && this.props.isShowPushpinVisibilityPopUp) {
      this.props.setIsShowingPushpinVisibilityPopUp(false);
      this.props.setIsShowingDeletePushpinPopUp(false);

    }
  }

  componentWillUnmount() {
    this.props.setIsShowingPushpinVisibilityPopUp(false);
    this.props.setIsShowingDeletePushpinPopUp(false);
    this.props.clearAllThumbnails();
  }

  analyticsEntityPreview(props) {
    const { issue, trackEvent, oxygen, origin, document, documentCollection } = props;

    const currentUserId = lodashGet(props, 'currentUser.attributes.id');
    const currentAssigneeId = issue.assignedTo || lodashGet(props, 'issue.assignees[0].id');
    const currentAssignedToType = issue.assignedToType || lodashGet(props, 'issue.assignees[0].type');
    const assignee = getAssigneeTypeByAssigneeId(currentAssigneeId, currentUserId, oxygen, currentAssignedToType);
    const currentDocument = origin === screenType.PROJECT && issue.targetUrn && documentCollection ? documentCollection[issue.targetUrn] : document ? document : null;

    //MixPanel Event - show issue when issue get open
    trackEvent(viewRFI(currentDocument, issue.status, origin, assignee));
  }

  renderSelectedTab() {
    switch (this.state.selectedTabId) {
      case PureIssuePreview.NavigationTabIds.DETAILS:
        return (
          <IssuePreviewDetailsTab
            issue={this.props.issue}
            container={this.props.container}
          />
        );
      case PureIssuePreview.NavigationTabIds.ATTACHMENTS:
        return (
          <IssuePreviewAttachmentsTab
            issue={this.props.issue}
            container={this.props.container}
          />
        );
      case PureIssuePreview.NavigationTabIds.ACTIVITY:
        return (
          <IssuePreviewActivityTab
            issue={this.props.issue}
            disableKeyboard={this.props.disableKeyboard}
            container={this.props.container}
            activityCommentEditorState={this.activityCommentEditorState}
            saveActivityCommentEditorState={(editorState) => { this.activityCommentEditorState = editorState; }}
          />
        );
      default:
        return null;
    }
  }

  renderTransitionPopup() {
    const { issue, oxygen, closeIssuePreview } = this.props;
    const {
      changeToStatus,
      pendingTransition,
      transitionFields,
      showCreateRevisionField,
    } = this.state;
    return (
      <AnimateHeightPopUp isOpen={!!changeToStatus}>
        <IssuePreviewTransitionPopUp
          issue={issue}
          changeToStatus={changeToStatus ? changeToStatus.value : null}
          pendingTransition={pendingTransition}
          transitionFields={transitionFields}
          closePopup={this.onCloseChangeStatusPopup}
          onStatusChange={this.handleOnStatusChange}
          onToggleCreateRevision={this.onToggleCreateRevision}
          showCreateRevisionField={showCreateRevisionField}
          oxygen={oxygen}
          closeIssuePreview={closeIssuePreview}
        />
      </AnimateHeightPopUp>
    );
  }

  onToggleCreateRevision() {
    const { transitionFields, showCreateRevisionField } = this.state;
    const copyTransitionFields = transitionFields.slice(0);
    const revisionCheckboxField = transitionFields.findIndex(
      (item) => item.fieldName === FE_TRANSITION_FIELDS.CREATE_REVISION
    );
    const defaultRevisionFields = transitionFields
      .map((item) => {
        if (item.fieldName === ISSUE_ATTRIBUTE_NAMES.CUSTOM_IDENTIFIER) {
          item.disabled = true;
          item.isMandatory = false;
        }
        return item;
      })
      .filter((item) => item.fieldName !== ISSUE_ATTRIBUTE_NAMES.CUSTOM_IDENTIFIER);
    const customIdField = {
      fieldName: ISSUE_ATTRIBUTE_NAMES.CUSTOM_IDENTIFIER,
      isMandatory: false,
      sortOrder: 1,
    };
    const initialCreateRevisionFieldState = showCreateRevisionField === undefined;
    if (initialCreateRevisionFieldState) {
      const copiedTransitionFields = transitionFields.map((item) => {
        if (item.fieldName === ISSUE_ATTRIBUTE_NAMES.CUSTOM_IDENTIFIER) {
          item.disabled = false;
          item.isMandatory = true;
        }
        return item;
      })
      this.setState((prevState) => ({
        transitionFields: copiedTransitionFields,
        showCreateRevisionField: !prevState.showCreateRevisionField,
      }));
    } else if (showCreateRevisionField) {
      this.setState((prevState) => ({
        transitionFields: defaultRevisionFields,
        showCreateRevisionField: !prevState.showCreateRevisionField,
      }));
    } else {
      // add the custom id field next to the checkbox field, and before the info field
      copyTransitionFields.splice(revisionCheckboxField + 1, 0, customIdField);
      this.setState((prevState) => ({
        transitionFields: copyTransitionFields,
        showCreateRevisionField: !prevState.showCreateRevisionField,
      }));
    }
  }

  handleOnStatusChange(newStatus) {
    const { issue } = this.props;
    const changeToStatus = newStatus;
    const transitionFields = changeToStatus.transitionAttributes;
    if (isEmpty(transitionFields)) {
      this.setState({ changeToStatus: null, pendingTransition: null, transitionFields: null });
      this.props.updateIssueAction(issue, { [ISSUE_ATTRIBUTE_NAMES.TRANSITION_ID]: newStatus.transitionId });
    } else {
      this.setState({ changeToStatus, pendingTransition: newStatus, transitionFields });
      this.props.issueTransitionPopupChange(true);
    }
  }

  updatePushpinVisibility() {
    this.props.togglePushpinVisibility(this.props.issue);
  }

  showPushpinVisibilityPopUp() {
    this.props.setIsShowingPushpinVisibilityPopUp(true);
  }

  hidePushpinVisibilityPopUp() {
    this.props.setIsShowingPushpinVisibilityPopUp(false);
  }

  showDeletePushpinPopUp() {
    this.props.setIsShowingDeletePushpinPopUp(true);
  }

  hideDeletePushpinPopUp() {
    this.props.setIsShowingDeletePushpinPopUp(false);
  }

  onCloseChangeStatusPopup() {
    this.setState({ changeToStatus: null, pendingTransition: null });
    this.props.issueTransitionPopupChange(false);
    this.resetCreateRevisionFields();
  }

  resetCreateRevisionFields() {
    const { transitionFields } = this.state;
    const copyTransitionFields = transitionFields.slice(0);
    const customIdFieldObj = transitionFields.find(
      (item) => item.fieldName === ISSUE_ATTRIBUTE_NAMES.CUSTOM_IDENTIFIER
    );
    const revisionCheckboxField = transitionFields.findIndex(
      (item) => item.fieldName === FE_TRANSITION_FIELDS.CREATE_REVISION
    );
    const customIdField = {
      fieldName: ISSUE_ATTRIBUTE_NAMES.CUSTOM_IDENTIFIER,
      isMandatory: false,
      disabled: true,
      readOnly: false,
      sortOrder: 1,
    };
    if (customIdFieldObj) {
      const copiedTransitionFields = transitionFields.map((item) => {
        if (item.fieldName === ISSUE_ATTRIBUTE_NAMES.CUSTOM_IDENTIFIER) {
          item.disabled = true;
          item.isMandatory = false;
        }
        return item;
      })
      this.setState({ transitionFields: copiedTransitionFields });
    } else {
      copyTransitionFields.splice(revisionCheckboxField + 1, 0, customIdField);
      this.setState({ transitionFields: copyTransitionFields });
    }
    this.setState({ showCreateRevisionField: undefined });
  }

  canEditStatus() {
    const { issue } = this.props;
    return getPermittedAttributes(issue).map(attr => attr.name ? attr.name : attr).includes(ISSUE_BE_ATTRIBUTE_NAMES[ISSUE_ATTRIBUTE_NAMES.STATUS])
      && getPermittedStatuses(issue).length > 0;
  }

  deletePushpin() {
    this.props.deletePushpin(this.props.issue);
  }

  handleTabChange(tab) {
    const { issue, trackEvent } = this.props;
    trackEvent(viewRfiTabSwitch(issue.id, issue.serverStatus, tab.id));
    this.setState({ selectedTabId: tab.id });    
  }

  render() {
    const { loading, issue, oxygen, isShowPushpinVisibilityPopUp, isShowDeletePushpinPopUp, isChangingPushpinVisibility, isDeletingPushpin, container, issueStatusOptions } = this.props;
    const { changeToStatus, selectedTabId } = this.state;
    if (loading || !issue) {
      return <Loader />;
    }

    const canEditStatus = this.canEditStatus();

    const contentClasses = classNames('IssuePreview__content', {
      'IssuePreview__content--shadowed': changeToStatus || isShowPushpinVisibilityPopUp,
    });

    // We need to ignore status change in the header if the change was done in call to action.
    const changeToStatusInHeader = changeToStatus ? issueStatusOptions.find(status => status.value === changeToStatus.value) : false;
    const CallToActionContainer = featureFlags.get(FEATURE_FLAGS.RFIS_SIB) ? StatusIndicator : IssuePreviewCallToAction;
    return (
      <StickyScrollableContainer className="IssuePreview">
        <StickyScrollableContainer.Header>
          <IssuePreviewHeader
            issue={issue}
            enableStatusChange={canEditStatus && !changeToStatus}
            changeToStatus={changeToStatusInHeader ? changeToStatus : null}
            issueStatusOptions={issueStatusOptions}
            onStatusChange={this.handleOnStatusChange}
            oxygen={oxygen}
            container={this}
            onPushpinVisibilityChange={this.showPushpinVisibilityPopUp}
            isUpdatingPushpinVisibilityState={isChangingPushpinVisibility}
          />
          {this.renderTransitionPopup()}
          <PushpinVisibilityPopUp
            modalContainer={container}
            isOpen={isShowPushpinVisibilityPopUp}
            issueIdentifier={issue.customIdentifier}
            isPushpinVisible={isPushpinVisible(issue)}
            isChangingPushpinVisibility={isChangingPushpinVisibility}
            onSave={this.updatePushpinVisibility}
            onCancel={this.hidePushpinVisibilityPopUp}
          />
          <DeletePushpinPopUp
            isOpen={isShowDeletePushpinPopUp}
            isDeletingPushpin={isDeletingPushpin}
            onDelete={this.deletePushpin}
            onCancel={this.hideDeletePushpinPopUp}
          />
          <CallToActionContainer
            onStatusChange={this.handleOnStatusChange}
          />
          <Tabs
            className="IssuePreview__navigation-tabs"
            tabs={this.state.tabs}
            selectedTab={this.state.tabs.find((nav) => selectedTabId === nav.id)}
            onTabChange={this.handleTabChange}
          />
        </StickyScrollableContainer.Header>
        <StickyScrollableContainer.Content className={contentClasses}>
          {this.renderSelectedTab()}
        </StickyScrollableContainer.Content>
      </StickyScrollableContainer>
    );
  }
}

PureIssuePreview.NavigationTabIds = {
  DETAILS: 'details',
  ATTACHMENTS: 'attachments',
  ACTIVITY: 'activity',
};

PureIssuePreview.NavigationTabs = [
  {
    id: PureIssuePreview.NavigationTabIds.DETAILS,
    name: () => T.translate('preview.tabs.details'),
  },
  {
    id: PureIssuePreview.NavigationTabIds.ATTACHMENTS,
    name: () => T.translate('preview.tabs.attachments'),
  },
  {
    id: PureIssuePreview.NavigationTabIds.ACTIVITY,
    name: () => T.translate('preview.tabs.activity'),
  },
];

PureIssuePreview.displayName = 'IssuePreview';

PureIssuePreview.defaultProps = {
  disableKeyboard: noop,
};

PureIssuePreview.propTypes = {
  container: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  issue: PropTypes.oneOfType([issueAttributesType, pendingIssueFormAttributesType]),
  oxygen: oxygenType.isRequired,
  disableKeyboard: PropTypes.func,
  updateIssueAction: PropTypes.func.isRequired,
  trackEvent: PropTypes.func.isRequired,
  origin: PropTypes.string,
  document: documentType,
  currentUser: userType,
  documentCollection: documentCollectionType,
  setIsShowingPushpinVisibilityPopUp: PropTypes.func.isRequired,
  setIsShowingDeletePushpinPopUp: PropTypes.func.isRequired,
  togglePushpinVisibility: PropTypes.func.isRequired,
  isShowPushpinVisibilityPopUp: PropTypes.bool.isRequired,
  isChangingPushpinVisibility: PropTypes.bool.isRequired,
  isDeletingPushpin: PropTypes.bool.isRequired,
  isShowDeletePushpinPopUp: PropTypes.bool.isRequired,
  clearAllThumbnails: PropTypes.func.isRequired,
  issueStatusOptions: statusOptionsArrayType.isRequired,
  closeIssuePreview: PropTypes.func.isRequired,
  isFetchingCurrentDocument: PropTypes.bool.isRequired,
  issueTransitionPopupChange: PropTypes.func.isRequired,
  deletePushpin: PropTypes.func.isRequired,
};


const mapStateToProps = (state) => {
  const { loading = true } = getCurrentPreviewIssueWrapper(state);
  const issue = getCurrentPreviewIssueAttributes(state);
  const oxygen = getOxygenMappings(state);
  const currentUser = getCurrentUser(state);
  const document = getCurrentDocument(state);
  const documentCollection = getDocumentCollection(state);
  const fetchingIssuesUrns = getFetchingIssuesUrns(state);
  const issueStatusOptions = getCurrentIssuePreviewStatusOptions(state);

  return {
    issue,
    loading,
    currentUser,
    oxygen,
    document,
    documentCollection,
    issueStatusOptions,
    isShowPushpinVisibilityPopUp: isShowPushpinVisibilityPopUp(state),
    isShowDeletePushpinPopUp: isShowDeletePushpinPopUp(state),
    isChangingPushpinVisibility: isChangingPushpinVisibility(state),
    isDeletingPushpin: isDeletingPushpin(state),
    isFetchingCurrentDocument: !!issue.targetUrn && !!fetchingIssuesUrns[issue.targetUrn],
  };
};

const mapDispatchToProps = {
  updateIssueAction,
  trackEvent,
  setIsShowingPushpinVisibilityPopUp,
  setIsShowingDeletePushpinPopUp,
  togglePushpinVisibility,
  clearAllThumbnails,
  issueTransitionPopupChange,
  deletePushpin,
};

export default connect(mapStateToProps, mapDispatchToProps)(PureIssuePreview);
